import React, {useMemo, useState} from 'react'
import {QueryGetEmpreendimentosRelatorioCompleto} from '../../../graphql'
import {Loader} from '../../../components/UI/Loader/Loader'
import {KTSVG} from '../../../../_metronic/helpers'
import {formatNumber} from '../../explorer/components/common'
import {BiExport, BiLinkExternal} from 'react-icons/bi'
import {ExportTable} from '../../../utils/ExportXLSX'
import DataTable from 'react-data-table-component'
import {customStylesTable} from '../../inteligencia-mercado/components/Common/common'

type Props = {
  active: boolean
  filtro: any[]
  toggleFilter: any
  toggleInfos: any
  objectFilter: any
}

type TableRow = {
  key: string
  empreendimentoId: number
  empreendimentoNome: string
  status: string
  temperaturaNome: string
  temperaturaCor: string
  qtdLotes: number
  areaEmpreendimento: number
  valorEmpreendimento: number
  loteId: number
  loteNome: string
  loteEndereco: string
  loteZoneamento: string
  lotebairro: string
  loteCep?: string
  loteNumeroContribuinte: string
  loteCorretor: string
  loteArea: number
  loteValor: number
  matricula: string
  loteSituacao: string
  loteSituacaoCor: string

  lotecontaminacao?:string
  lotemelhoramento_viario?:string
  lotedesapropriacao?:string
  lotepatrimonio_cultural?:string
  loteoperacao_urbana?:string
}

const TableRelatorioEmpreendimentosLotes: React.FC<Props> = ({
  filtro,
  toggleFilter,
  toggleInfos,
  objectFilter,
}) => {
  const [pages] = useState(0)

  const {data} = QueryGetEmpreendimentosRelatorioCompleto({
    variables: {
      pagination: {pagina: pages, quantidade: 1000},
      filtro: {
        fields: filtro,
        objectFilter: {
          ...{
            empreendimento_terreno:
              objectFilter.id_corretor?.objectFilter?.empreendimento_terreno || undefined,
          },
          ...{users: objectFilter.id_equipe?.objectFilter?.users || undefined},
        },
      },
      situation: undefined,
    },
  })

  const rowsData = useMemo(() => {
    if (!data?.GetEmpreendimentos?.result) return []

    const rows: TableRow[] = []

    data.GetEmpreendimentos.result.forEach((empreendimento) => {
      const lotes = empreendimento.empreendimento_terreno || []
      const valorTotalTerreno =
        Number(empreendimento.preco_medio_m2 || 0) * Number(empreendimento.area_total_terreno || 0)

      const getCorretores = (terreno: any) => {
        const corretoresRaw = terreno?.terreno_corretor
        const corretoresArray = Array.isArray(corretoresRaw)
          ? corretoresRaw
          : corretoresRaw
          ? [corretoresRaw]
          : []

        return corretoresArray
          .map((c) => c.corretor?.nome)
          .filter((name) => !!name && name !== 'Sem corretor')
      }

      lotes.forEach((item, index) => {
        const terreno = item?.terreno
        const areaLote = Number(terreno?.area_iptu || 0)
        const valorLote = Number(empreendimento.preco_medio_m2 || 0) * areaLote
        const corretoresLote = getCorretores(terreno).join(' / ')
        console.log(empreendimento)
        rows.push({
          key: `lote-${empreendimento.id}-${terreno?.id || index}`,
          empreendimentoId: empreendimento.id,
          empreendimentoNome: empreendimento.nome || 'N�o informado',
          status: empreendimento.empreendimento_situacao?.nome || '-',
          temperaturaNome: empreendimento.empreendimento_temperatura?.nome || '-',
          temperaturaCor: empreendimento.empreendimento_temperatura?.cor || '#d1d5db',
          qtdLotes: lotes.length,
          areaEmpreendimento: Number(empreendimento.area_total_terreno || 0),
          valorEmpreendimento: valorTotalTerreno,
          loteId: terreno?.id,
          loteNome: terreno?.nome || `Lote ${index + 1}`,
          loteEndereco:
            [terreno?.endereco, terreno?.numero]
              .filter((itemEndereco) => !!itemEndereco)
              .join(', ') || '-',
          loteZoneamento: terreno?.zoneamento || '-',
          lotebairro: terreno?.bairro || '-',
          loteCep: terreno?.cep || '-',
          loteNumeroContribuinte: terreno?.numero_contribuinte || '-',
          matricula: terreno?.matricula || '-',
          loteCorretor: corretoresLote || '-',
          loteArea: areaLote,
          loteValor: valorLote,
          loteSituacao: terreno?.terreno_situacao_cliente?.nome || '-',
          loteSituacaoCor: terreno?.terreno_situacao_cliente?.cor || '-',
          lotecontaminacao:terreno?.contaminacao || '-',
          lotemelhoramento_viario: terreno?.melhoramento_viario || '-',
          lotedesapropriacao: terreno?.desapropriacao || '-',
          lotepatrimonio_cultural: terreno?.patrimonio_cultural || '-',
          loteoperacao_urbana: terreno?.operacao_urbana || '-'

        })
      })
    })

    return rows
  }, [data])

  const columnsData = useMemo(() => {
    return [
      {
        name: '',
        cell: (row: TableRow) => (
          <a
            href={`/empreendimentos/details/${row.empreendimentoId}#composicao-terrenos`}
            target='_blank'
            rel='noreferrer'
            className='fs-2'
          >
            <BiLinkExternal />
          </a>
        ),
        sortable: false,
        width: '55px',
      },
      {
        name: 'id',
        selector: (row: TableRow) => row.empreendimentoId,
        sortable: true,
        minWidth: '10px',
        wrap: true,
      },
      {
        name: 'Empreendimento',
        selector: (row: TableRow) => row.empreendimentoNome,
        sortable: true,
        minWidth: '260px',
        wrap: true,
      },
        {
        name: 'Bairro',
        selector: (row: TableRow) => row.lotebairro,
        sortable: true,
        minWidth: '260px',
        wrap: true,
      },
      {
        name: 'Status',
        selector: (row: TableRow) => row.status,
        sortable: true,
        width: '140px',
      },
      {
        name: 'Temperatura',
        cell: (row: TableRow) =>
          row.temperaturaNome ? (
            <span
              className='badge badge-temperatura fw-bold me-auto px-4 py-2 p-5'
              style={{backgroundColor: row.temperaturaCor}}
            >
              {row.temperaturaNome}
            </span>
          ) : (
            '-'
          ),
        sortable: false,
        width: '150px',
        center: true,
      },
      {
        name: 'Qtd. Lotes',
        selector: (row: TableRow) => row.qtdLotes,
        sortable: true,
        width: '120px',
      },
      {
        name: 'Área Emp. (m²)',
        selector: (row: TableRow) => row.areaEmpreendimento,
        format: (row: TableRow) =>
          row.areaEmpreendimento ? formatNumber(row.areaEmpreendimento, 'decimal') : '-',
        sortable: true,
        right: true,
        width: '140px',
      },
      {
        name: 'Valor Empreendimento',
        selector: (row: TableRow) => row.valorEmpreendimento,
        format: (row: TableRow) =>
          row.valorEmpreendimento ? formatNumber(row.valorEmpreendimento, 'currency') : '-',
        sortable: true,
        right: true,
        width: '170px',
      },
      // {
      //   name: 'Lote',
      //   selector: (row: TableRow) => row.loteNome,
      //   sortable: true,
      //   minWidth: '200px',
      //   wrap: true,
      // },
      {
        name: 'id Lote',
        selector: (row: TableRow) => row.loteId,
        sortable: true,
        minWidth: '30px',
        wrap: true,
      },
      {
        name: 'Endereço Lote',
        selector: (row: TableRow) => row.loteEndereco,
        sortable: true,
        minWidth: '260px',
        wrap: true,
      },
      {
        name: 'Situação',
        cell: (row: TableRow) =>
          row.loteSituacao ? (
            <span
              className='badge badge-temperatura fw-bold me-auto px-4 py-2 p-5'
              style={{backgroundColor: row.loteSituacaoCor}}
            >
              {row.loteSituacao}
            </span>
          ) : (
            '-'
          ),
        sortable: true,
        minWidth: '260px',
        wrap: true,
      },

      {
        name: 'Zoneamento Lote',
        selector: (row: TableRow) => row.loteZoneamento,
        sortable: true,
        width: '160px',
      },
      {
        name: 'Nº Contribuinte',
        selector: (row: TableRow) => row.loteNumeroContribuinte,
        sortable: true,
        width: '170px',
      },
      {
        name: 'Matricula',
        selector: (row: TableRow) => row.matricula,
        sortable: true,
        width: '170px',
      },
      {
        name: 'Corretor Lote',
        selector: (row: TableRow) => row.loteCorretor,
        sortable: true,
        minWidth: '220px',
        wrap: true,
      },
      {
        name: 'Área Lote (m²)',
        selector: (row: TableRow) => row.loteArea,
        format: (row: TableRow) =>
          row.loteArea ? formatNumber(row.loteArea, 'inteiro') + ' m²' : '-',
        sortable: true,
        right: true,
        width: '130px',
      },
      {
        name: 'Valor Lote',
        selector: (row: TableRow) => row.loteValor,
        format: (row: TableRow) => (row.loteValor ? formatNumber(row.loteValor, 'currency') : '-'),
        sortable: true,
        right: true,
        width: '150px',
      },
    ]
  }, [])

  function exportTable() {
    const dataToExport = rowsData.map((row) => ({
      Empreendimento: row.empreendimentoNome,
      Bairro: row.lotebairro,
      Status: row.status,
      Temperatura: row.temperaturaNome,
      'Qtd. Lotes': row.qtdLotes,
      'Área Empreendimento (m²)': row.areaEmpreendimento
        ? formatNumber(row.areaEmpreendimento, 'decimal')
        : '-',
      'Valor Empreendimento': row.valorEmpreendimento
        ? formatNumber(row.valorEmpreendimento, 'currency')
        : '-',
      Lote: row.loteNome,
      'Endereço Lote': row.loteEndereco,
      Situação: row.loteSituacao,
      'Zoneamento Lote': row.loteZoneamento,
      'Nº Contribuinte': row.loteNumeroContribuinte,
      Matricula: row.matricula,
      'Corretor Lote': row.loteCorretor,
      'Área Lote (m²)': row.loteArea ? formatNumber(row.loteArea, 'decimal') : '-',
      'Valor Lote': row.loteValor ? formatNumber(row.loteValor, 'currency') : '-',

      'Contaminção':row.lotecontaminacao,
      'Melhoramento Viário':row.lotemelhoramento_viario,
      'Desapropriação':row.lotedesapropriacao,
      'Patrimônio Cultural':row.lotepatrimonio_cultural,
      'Operação Urbana':row.loteoperacao_urbana
    }))

    ExportTable(dataToExport, '', 'Relatorio Empreendimentos Lotes.xlsx')
  }

  if (!data) {
    return (
      <div className='card  px-10 py-6'>
        <div className='border-0'>
          <div className='row'>
            <div className='col-xl-12'>
              <div className='card-xxl-stretch '>
                <div className='card-header border-0    p-0'>
                  <h3 className='card-title align-items-start flex-column'>
                    <span className='card-label fw-bolder fs-3 mb-1'>
                      <KTSVG
                        path='/media/icons/duotune/files/fil003.svg'
                        className='svg-icon-1 svg-icon-gray-500 me-1'
                      />
                      Relatório de Empreendimentos e Lotes
                    </span>
                  </h3>
                </div>
                <div className='separator my-2'></div>
                <Loader text={'caregando...'}></Loader>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className='card  px-10 py-6'>
      <div className='border-0'>
        <div className='row'>
          <div className='col-xl-12'>
            <div className='card-header border-0 p-0'>
              <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bolder fs-3 mb-1'>
                  <KTSVG
                    path='/media/icons/duotune/files/fil003.svg'
                    className='svg-icon-1 svg-icon-gray-500 me-1'
                  />
                  Relatório de Empreendimentos e Lotes
                </span>
              </h3>
              <div
                className='card-toolbar all-end'
                data-bs-toggle='tooltip'
                data-bs-placement='top'
                data-bs-trigger='hover'
                title='Exportar tabela'
              >
                <button className='me-4 btn btn-sm btn-flex  btn-primary' onClick={exportTable}>
                  <BiExport></BiExport>
                  Exportar
                </button>

                {/* <button
                  className='me-4 btn btn-sm btn-flex btn-light btn-light-warning'
                  data-kt-menu-trigger='click'
                  data-kt-menu-placement='bottom-end'
                  data-kt-menu-flip='top-end'
                  onClick={toggleInfos}
                >
                  <KTSVG
                    path='/media/icons/duotune/general/gen046.svg'
                    className='svg-icon-5 svg-icon-gray-500 me-1'
                  />
                  Infos
                </button> */}
                <button
                  className='me-4 btn btn-sm btn-flex btn-light btn-secondary'
                  data-kt-menu-trigger='click'
                  data-kt-menu-placement='bottom-end'
                  data-kt-menu-flip='top-end'
                  onClick={toggleFilter}
                >
                  <KTSVG
                    path='/media/icons/duotune/general/gen031.svg'
                    className='svg-icon-5 svg-icon-gray-500 me-1'
                  />
                  Filtros
                </button>
              </div>
            </div>
            <div className='separator my-2'></div>
            <div className='card-body p-0' style={{maxWidth: '188vh'}}>
              <div className='table-responsive w-100 '>
                <DataTable
                  title='Relatório de Lotes'
                  noHeader={true}
                  customStyles={customStylesTable}
                  columns={columnsData}
                  subHeader={false}
                  data={rowsData}
                  pagination={true}
                  paginationRowsPerPageOptions={[10, 25, 50, 100]}
                  highlightOnHover
                  pointerOnHover
                  striped
                  dense
                  paginationPerPage={50}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export {TableRelatorioEmpreendimentosLotes}
